import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import classnames from 'classnames';
import Signup from 'sharedFreePages/Signup';
import Onboarding from 'sharedFreePages/Onboarding';
import AwaitProvision from 'sharedFreePages/AwaitProvision';
import { useGlobalState } from 'hooks/useGlobalState';
import { useMunchkinTracking } from 'hooks/useMunchkinTracking';
import styles from '../PageContent/PageContent.module.scss';

export default function SharedFreePageContent() {
  const [{ signup, waitingScreen }] = useGlobalState();
  useMunchkinTracking();
  return (
    <div
      className={classnames(styles.contentContainer, {
        [styles.noScroll]: waitingScreen.visible,
      })}
    >
      <Switch>
        <Route exact path="/" component={Signup} />
        <Route path="/onboarding">
          {signup.status ? <Onboarding /> : <Redirect to="/" />}
        </Route>
        <Route path="/awaitProvision">
          {signup.status ? <AwaitProvision /> : <Redirect to="/" />}
        </Route>
      </Switch>
    </div>
  );
}
